import setupMailDeeplinkCommonPostRender from './setupMailDeeplinkCommonPostRender';
import { lazyInitializeCalendarsDataForModule } from 'owa-calendar-bootstrap-utils';
import { initializeFeature } from 'owa-feature-flags';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';
import { isInAnyInboxPlusExperiment } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';
import { lazyLoadLightningPrimaryView } from 'owa-lightning-view';
import { lazyModule as lazyMailFavoritesStore } from 'owa-mail-favorites-store';
import { initializeFocusedInboxConfig } from 'owa-mail-focused-inbox-config';
import { subscribeSaveFocusInboxOptionStitch } from 'owa-mail-focused-inbox-config';
import { lazyPrefetchFrequentlyUsedFolders } from 'owa-mail-folder-forest-actions';
import { lazySubscribeToInboxPlusRowNotifications } from 'owa-mail-inbox-plus-actions';
import { logInboxPlusExperimentData } from 'owa-mail-inbox-plus-store';
import { reloadInboxPostBoot } from 'owa-mail-list-actions';
import { subscribeSaveReadingPanePositionOptionStitch } from 'owa-mail-module-orchestrator';
import { getMoveToMruList } from 'owa-mail-move-mru';
import { lazyRegisterSearchStoreOrchestrators } from 'owa-mail-search';
import { showNotificationOnMailboxQuotaWarning } from 'owa-mail-triage-action';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazyInitializeUpNextV2 } from 'owa-upnext-v2';
import {
    lazySubscribeToNewMailNotifications,
    lazySubscribeToReminderNotifications,
    lazySubscribeToSocialActivityNotifications,
} from 'owa-app-notifications-core';
import { lazyGovern } from 'owa-shared-post-boot';
import { lazyFetchCategoryDetails } from 'owa-categories';

export default function setupMailModuleCommonPostRender() {
    setupMailDeeplinkCommonPostRender();

    // important to minimize cover the delta between session data and subscription established
    reloadInboxPostBoot();

    // don't govern stiches
    subscribeSaveFocusInboxOptionStitch();
    subscribeSaveReadingPanePositionOptionStitch();

    lazyGovern.importAndExecute(
        () => lazyMailFavoritesStore.import(),
        {
            condition: isInAnyInboxPlusExperiment(),
            task: logInboxPlusExperimentData,
        },
        initializeFocusedInboxConfig,
        getMoveToMruList,
        () => lazyInitializeCalendarsDataForModule.importAndExecute(),
        () => {
            initializeFeature('tri-upNextV2', () => {
                lazyInitializeUpNextV2.importAndExecute();
            });
        },
        () => lazySubscribeToNewMailNotifications.importAndExecute(),
        () => lazySubscribeToReminderNotifications.importAndExecute(),
        {
            condition: !isConsumer(),
            task: () => lazySubscribeToSocialActivityNotifications.importAndExecute(),
        },
        {
            condition: isInboxPlusEnabled(),
            task: () => {
                lazySubscribeToInboxPlusRowNotifications
                    .import()
                    .then(subscribeToInboxPlusRowNotifications => {
                        subscribeToInboxPlusRowNotifications();
                    });
            },
        },
        showNotificationOnMailboxQuotaWarning,
        () => lazyLoadLightningPrimaryView.importAndExecute(),
        () => lazyPrefetchFrequentlyUsedFolders.importAndExecute(),
        () => lazyRegisterSearchStoreOrchestrators.import(),
        () => lazyFetchCategoryDetails.importAndExecute()
    );
}
